module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4 pv3 ph4 pl-box-shadow"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs center-xs title"
  }, [_c('span', [_vm._v("Time Spent on Parlay")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.time_spent_on_parlay_description),
      expression: "time_spent_on_parlay_description"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nt4 end-xs"
  }, [_c('pl-menu', {
    attrs: {
      "menuSize": 2,
      "direction": "right"
    }
  }, [_c('pl-button', {
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_vm._v("\n            " + _vm._s(_vm.selected_filter) + "\n            "), _c('i', {
    staticClass: "fa fa-caret-down pa1"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "menu-content": ""
    }
  }, _vm._l((_vm.timeShown), function(selected, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.selectFilter(selected)
        }
      }
    }, [_vm._v("\n              " + _vm._s(selected) + "\n            ")])
  }), 0)], 1)], 1)])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "time-spent-on-parlay-graph-data"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3a853af6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/analytics/standardGraphs/timeSpentOnParlayGraph.vue
// module id = 2158
// module chunks = 61